import { Row, Container, Button } from 'react-bootstrap';
import Link from 'next/link';

export default function HostJoinCallToAction() {
  return (
    <Row className="bg-light">
      <Container className="p-5 text-center">
        <Link href="/hosts/join/apply" legacyBehavior>
          <Button size="lg" variant="primary">
            Apply to Host
          </Button>
        </Link>
        <Link href="/help/contact" passHref legacyBehavior>
          <Button variant="link" className="text-dark" size="lg">
            Contact Us
          </Button>
        </Link>
      </Container>
    </Row>
  );
}
